package ui.app.assign.detail.definition

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import ssoft.frontend.generated.resources.Res
import ssoft.frontend.generated.resources.layer_bottom_detail__image_pick_label
import ui.app.assign.detail.AppDetailScope
import ui.widget.Space

@Composable
fun AppDetailScope.AppDefOfImage(
    wrapper: AppDetailScope.Wrapper,
    nnvl: AppDetailScope.WrapperDefinition.OfImage
) {
    if (display.isMobile) {
        Column {
            DefaultFields(
                nnvl = wrapper,
                modifier = Modifier.fillMaxWidth(),
                mainContent = {
                    ImagePicker(
                        field = nnvl.image,
                        label = Res.string.layer_bottom_detail__image_pick_label,
                        wrapper = wrapper,
                        modifier = Modifier.fillMaxWidth()
                    )
                    Space(16.dp)
                })
        }
    } else {
        Row {
            Column(Modifier.weight(1F)) {
                DefaultFields(
                    nnvl = wrapper,
                    modifier = Modifier.fillMaxWidth()
                )
            }
            Space(16.dp)
            Column(Modifier.weight(1F)) {
                ImagePicker(
                    field = nnvl.image,
                    label = Res.string.layer_bottom_detail__image_pick_label,
                    wrapper = wrapper,
                    modifier = Modifier.fillMaxWidth()
                )
            }
        }
    }
    Space(64.dp)
}
